import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface InternalAuditInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function InternalAuditInternalControls({ onBack, setActiveSection, controlsListSection }: InternalAuditInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Internal Audit"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
